import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { css, useTheme } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';
import BirdiLogoSVG from '@birdi/icons/birdi-logo-navy.svg';
// @ts-ignore - JS file without types
import * as authActions from '../actions';
import * as styles from './styles';

interface VerifyEmailWithTokenProps {
  verifyEmailWithTokenAndSignIn: (
    userId: string,
    verificationToken: string,
  ) => Promise<any>;
}

const VerifyEmailWithToken: React.FC<VerifyEmailWithTokenProps> = (props) => {
  const theme = useTheme() as BirdiTheme;
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const userId = searchParams.get('id');
    const token = searchParams.get('token');
    if (!userId || !token) {
      setInvalid(true);
    } else {
      props
        .verifyEmailWithTokenAndSignIn(userId, token)
        .catch(() => setInvalid(true));
    }
  }, []);

  return (
    <>
      {/* Logo - Fixed at top */}
      <div css={styles.logoContainer}>
        <BirdiLogoSVG />
      </div>

      {/* Scrollable Content */}
      <div css={styles.scrollableContent}>
        {/* Header Section */}
        <div css={styles.headerSection}>
          <h1 css={styles.title}>Verifying your email</h1>
          {!invalid && (
            <p css={styles.subtitle}>
              Please wait while we verify your email address...
            </p>
          )}
        </div>

        {/* Content */}
        {invalid && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 1rem;
            `}
          >
            <div css={styles.errorMessage}>
              This token is invalid or expired.
            </div>
            <p css={styles.subtitle}>
              <Link
                to="/resend-verification"
                css={(theme: BirdiTheme) => css`
                  color: ${theme.deepOcean};
                  text-decoration: underline;
                  font-weight: 500;

                  &:hover {
                    text-decoration: none;
                  }
                `}
              >
                Resend verification token
              </Link>
              .
            </p>
          </div>
        )}
      </div>

      {/* Fixed Footer - Help Link */}
      <div css={styles.fixedFooter}>
        <div css={styles.helpLink}>
          Need help? <a href="mailto:support@birdi.io">Contact support</a>
        </div>
      </div>
    </>
  );
};

export default connect(
  (state: any) => ({
    auth: state.auth,
  }),
  (dispatch: any) => ({
    verifyEmailWithTokenAndSignIn: (
      userId: string,
      verificationToken: string,
    ) =>
      dispatch(
        authActions.verifyEmailWithTokenAndSignIn(userId, verificationToken),
      ),
  }),
)(VerifyEmailWithToken);
